import { createSelector } from 'reselect';
import { getSelectedOrganization, getLoadingStatuses } from 'helpers/selectors';

const getMaintenanceSchedule = ({ powertrainTools }) => {
    return powertrainTools.sensorFirmwareManagement.maintenanceSchedule ?? {};
};

const getMicroServiceScheduleData = ({ powertrainTools }) => {
    return powertrainTools.sensorFirmwareManagement.microServiceMaintenance ?? [];
};

export const getModel = createSelector([
    getMaintenanceSchedule,
    getSelectedOrganization,
    getLoadingStatuses,
    getMicroServiceScheduleData
],
    (
        maintenanceSchedule,
        organizationID,
        generalFilterLoadingStatuses,
        microServiceMaintenance
    ) => {
        return {
            maintenanceSchedule,
            organizationID,
            generalFilterLoadingStatuses,
            microServiceMaintenance
        };
    });
